import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { Level } from './Level';
import { Item } from '@bloomays-lib/types.shared';

export type ItemTalentLevelProps = {
  skill: { id?: string; label: string; iso?: boolean }; // TODO !! ceci ne doit pas s'appelle skill mais item !
  onClick?: (e?: any) => void;
  level?: number;
  match?: any;
  disabled?: boolean;
  clickable?: boolean;
  clickableLevel?: boolean;
  current?: boolean;
  onClickCross?: (item: Item) => void;
};

type DivProp = {
  round?: boolean;
  disabled?: boolean;
};

const StyledLabel = styled('span')<DivProp>(
  ({ theme, disabled }) => `
  color:  ${disabled ? `${theme.palette.neutral[30]}` : `${theme.palette.neutral[80]}`};
  font-size: 14px;
`,
);

const StyledDiv = styled('div')<DivProp>(
  ({ theme, round, disabled }) => `
  background-color: ${disabled ? `${theme.palette.neutral[10]}` : `${theme.palette.blue[20]}`};
  display: flex;
  align-items: center;
  align-content: flex-end;
  justify-content: center;
  border-radius: ${round ? '30px' : '5px'};
  padding: 4px 6px 4px 6px;
  width: fit-content;
  gap: 7.5px;
  height: 24px;
`,
);

const StyledCloseIcon = styled(CloseIcon)(
  () => `
  &:hover {
    cursor: pointer;
  }
  `,
);

const ItemTalentLevel = ({
  skill,
  onClick,
  clickable,
  level,
  disabled,
  clickableLevel,
  onClickCross,
}: ItemTalentLevelProps) => {
  return (
    <StyledDiv disabled={disabled} round={clickable}>
      <StyledLabel disabled={disabled}>{skill.label}</StyledLabel>
      {(level || level === 0) && <Level onClick={onClick} level={level} clickable={clickableLevel} />}
      {clickable && (
        <StyledCloseIcon
          fontSize="small"
          onClick={
            onClickCross
              ? () => {
                  onClickCross(skill as any);
                }
              : undefined
          }
        />
      )}
    </StyledDiv>
  ) as React.ReactElement;
};

export default ItemTalentLevel;
export { ItemTalentLevel };
